import React, { useEffect, useState } from "react";
import Page from "../components/Page";
import Banner from "../components/banner";
import { useIntl } from "react-intl";
import { getPrivacy_req } from "../api/api";
import { useSelector } from "react-redux";

const TermsOfUse = () => {
    const intl = useIntl();
    const [data, setData] = useState(null);

    const locale = useSelector((state) => state.global.locale);
    const getPrivacyReq = async () => {
        const getPrivacyData = await getPrivacy_req();
        setData(getPrivacyData?.data?.content);
    };
    useEffect(() => {
        getPrivacyReq();
    }, [locale]);
    const addText = () => {
        return { __html: data };
    };

    return (
        <Page meta={{
            title: 'Շախմատների և Նարդիների Մեծ Տեսականի | Handle Brand',
            description: 'Գնել շախմատ Երևանում | Գնել նարդի և  խաղաքարեր | Փայտե հուշանվերների լայն տեսկանի Handle.am - ում | Պատվիրել օնլայն այստեղ'
        }}>
            <div className="terms-of-use text-page">
                <Banner
                    title={intl.messages.termsOfUse}
                    currentPage={intl.messages.termsOfUse}
                />
                <div className="wrapper" dangerouslySetInnerHTML={addText()}>
                    {/* <p>Return or exchange of ordered goods</p>
        <p>
          If the product you purchased does not have qualitative and
          quantitative changes, you can return it within 14 days by presenting a
          cash receipt or invoice.
        </p>
        <p>Refunds are made to the account from which payment was made.</p>
        <p>
          If your desire to return a product is due to its quality
          characteristics, with the help of our courier you can exchange the
          goods for another.
        </p>
        <p>
          The same applies to cases when you mistakenly ordered goods of a
          particular product group, but want to replace it with another product
          of your choice of the same product group. In such cases, you will be
          charged the amount of the difference in the price of the goods, if
          any, and payment for delivery will not be charged.
        </p>
        <p>Responsibility for the Site:</p>
        <p>
          An order placed on the Handle.am website is an offer made by you to
          the Company in order to purchase and deliver any product. This offer
          is considered accepted if we send an order confirmation email to your
          e-mail, in which all the details of the order are indicated. This
          letter is an agreement between you and the Site.
        </p>
        <p>Delivery in Yerevan is free.</p> */}
                </div>
            </div>
        </Page>
    );
};

export default TermsOfUse;
